import React, { useState } from 'react';
import MainCalculatorsList from './MainCalculators';
import SharedHelmet from '.././Helmet'
import RelatedLinks from '../RelatedLinks';
import { FirstAds, SecondAds , MobileUnderCalAds } from "../../Ads";
const TITLE = 'حاسبة حجم الكرة - حساب حجم الكرة بناءً على نصف القطر';
const DESCRIPTION = 'حاسبة حجم الكرة تقوم بحساب حجم الكرة بناءً على نصف القطر المدخل.';
const KEYWORDS = 'حجم الكرة, حساب حجم الكرة, حاسبة حجم الكرة';
const OG_URL = 'https://do-calculate.com/calculator/ar/sphere-volume';
function Calculator() {
    const [radius, setRadius] = useState('');
    const [volume, setVolume] = useState('');
    const [error, setError] = useState('');
    const handleCalculate = () => {
        if (!radius) {
            setError('الرجاء إدخال قيمة نصف القطر بشكل صحيح');
            setVolume('');
            return;
        }
        const radiusValue = parseFloat(radius);
        if (isNaN(radiusValue) || radiusValue <= 0) {
            setError('الرجاء إدخال قيمة صحيحة وموجبة لنصف القطر');
            setVolume('');
            return;
        }
        const volumeValue = (4 / 3) * Math.PI * Math.pow(radiusValue, 3);
        setVolume(volumeValue.toFixed(2));
        setError('');
    };
    return (
        <div className="rtl">
            <SharedHelmet TITLE={TITLE} DESCRIPTION={DESCRIPTION} KEYWORDS={KEYWORDS} OG_URL={OG_URL}  />
            <div className="row">
                <div className="col-12 col-md-8">
                    <FirstAds />
                </div>
            </div>
            <div className="row">
                <div className="col-12 col-md-8">
                    <br />
                    <div className="bg-success text-white text-center" style={{ height: '40px' }}>
                        <h1 style={{ fontSize: '17px' }}>{TITLE}</h1>
                    </div>
                            <div className="border border-light">
                                <div className="row">
                                    <div>
                                        <h2 style={{ fontSize: '18px' }}>كيفية حساب حجم الكرة</h2>
                                        <p>
                                            يمكن حساب حجم الكرة بناءً على نصف القطر بواسطة القانون التالي:
                                        </p>
                                        <p>
                                            حجم الكرة = (4/3) × π × (نصف القطر)^3
                                        </p>
                                        <p>
                                            الرجاء إدخال قيمة نصف القطر لحساب حجم الكرة.
                                        </p>
                                        <hr />
                                    </div>
                                </div>
                                    <MobileUnderCalAds />
                                <div className="row">
                                    <div className="col-sm-12 col-md-7 calculatorStyle">
                                        <div className='p-3 mb-2 bg-success text-white'>
                                            <h2 style={{ fontSize: '16px' }}>{TITLE} </h2>
                                        </div>
                                        <hr />
                                        <div dir="rtl">
                                            <div>
                                                <div className="form-group d-flex align-items-center">
                                                    <b>
                                                        <label className="form-label ms-2">نصف القطر (سم)</label>
                                                    </b>
                                                    <input
                                                        type="number"
                                                        placeholder="نصف القطر"
                                                        value={radius}
                                                        onChange={(e) => setRadius(e.target.value)}
                                                        className="form-control"
                                                        style={{ width: '150px' }}
                                                    />
                                                </div>
                                                <br />
                                                <button
                                                    className="btn btn-success"
                                                    style={{ fontSize: '20px' }}
                                                    onClick={handleCalculate}
                                                >
                                                    احسب حجم الكرة
                                                </button>
                                            </div>
                                            <br />
                                            <div>
                                                {error !== '' ? (
                                                    <p className='p-3 mb-2 bg-warning text-white'>خطأ: {error}</p>
                                                ) : (
                                                    <>
                                                        {volume !== '' && (
                                                            <p className='p-3 mb-2 bg-success text-white'>
                                                                حجم الكرة: {volume} سم³
                                                            </p>
                                                        )}
                                                    </>
                                                )}
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <hr />
                                <div className="row">
                                    <RelatedLinks />
                                    <hr />
                                </div>
                            </div>
                </div>
                <div className="col">
                    <SecondAds />
                    <br />
                    <MainCalculatorsList />
                    <br />
                </div>
            </div>
             <br />
        </div>
    );
}
export default Calculator;
